import { TFunction } from "i18next";

export const validateUrlField = (value: any, callback: (error?: React.ReactNode) => void, t: TFunction<"translation", undefined>, isRequired: boolean, fieldName: string, domain: string) => {
  const urlRegex = /^(https?:\/\/)?([\w-]+\.)+[\w-]+(\/[\w- .\/?%&=]*)?$/;
  const escapedDomain = domain.replace(/\./g, '\\.');
  const domainRegex = domain.toLowerCase() === 'linkedin.com'
    ? /^(https?:\/\/)?([\w-]+\.)*linkedin\.com\/.+/i
    : new RegExp(`^(https?:\\/\\/)?(www\\.)?${escapedDomain}\\/.+`, 'i');
  const trimmedValue = (value || '').trim();

  // Accept "NA" or "N/A" as valid input (case-insensitive)
  if (trimmedValue.toLowerCase() === 'na' || trimmedValue.toLowerCase() === 'n/a') {
    return callback();
  }

  if (!isRequired && !trimmedValue) {
    return callback();
  }

  if (!trimmedValue) {
    return callback(t('form_validation_messages.empty_link', {fieldName}));
  }

  if (!urlRegex.test(trimmedValue)) {
    return callback(t('form_validation_messages.invalid_link'));
  }

  if (!domainRegex.test(trimmedValue)) {
    return fieldName === 'Calendly' ? callback(t('form_validation_messages.invalid_calendly_link', {domain})) : callback(t('form_validation_messages.invalid_domain_link', {domain}));
  }

  return callback();
}

export const validateEmailField = (value: any, callback: (error?: React.ReactNode) => void, t: TFunction<"translation", undefined>) => {
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

  if (!value || value.trim().length === 0) {
    callback(t('form_validation_messages.empty_email'));
  } else if (value.length > 100) {
    callback(t('form_validation_messages.long_email'));
  } else if (!emailRegex.test(value)) {
    callback(t('form_validation_messages.invalid_email'));
  } else {
    callback();
  }
}

export const checkEmptyField = (value: any, callback: (error?: React.ReactNode) => void, message: string) => {
  !value || value.trim().length === 0 ? callback(message) : callback()
}

export const validateZipCode = (value: any, callback: (error?: React.ReactNode) => void, t: TFunction<"translation", undefined>, isRequired: boolean) => {
  const zipCodeRegex = /^\d{5}$/;
  const trimmedValue = (value || '').trim();

  if (!isRequired && !trimmedValue) {
    return callback();
  }

  if (!trimmedValue) {
    return callback(t('form_validation_messages.empty_zip_code'));
  }

  if (!zipCodeRegex.test(trimmedValue)) {
    return callback(t('form_validation_messages.invalid_zip_code'));
  }

  return callback();
}